//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {GetSysPublicPageMsgById} from 'service/smsapisg'
import { formatStandardTitle } from '@/utils/standard'
export default {
    data () {
        return {
            id:"",
            appId:"",
            SysMsgTitle:"",
            SysMsgTime:"",
            Abstract:"",
            SysMsgContent:""
        }
    },
    components: {
    },
    mounted () {
        // document.title="系统消息"
        formatStandardTitle('系统消息')
        this.id = this.$route.query.id;
        this.appId = this.$route.query.appId;
     this.init();
    },
    methods: {
        init:function () {
            var _this=  this;
            if(_this.appId){
                var getData = {
                    "id":_this.id,
                    "appId":_this.appId
                }
            }else {
                 getData = {
                    "id":_this.id
                }
            }
            GetSysPublicPageMsgById(getData,function (msg) {
                let data = msg.data;
                if (msg.state == '1') {
                    _this.SysMsgTitle=data.SysMsgTitle;
                    _this.SysMsgTime = data.SysMsgTime
                    _this.Abstract = data.Abstract
                    _this.SysMsgContent = data.SysMsgContent
                }else{
                    console.log(msg.errmsg);
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/module/PicActivity/ActivityPage2.vue